import { menu as participantesMenu } from './participantes/menu';

export const brasilMaisMenu = {
    label: 'BRASIL MAIS',
    icon: 'pi pi-book',
    rules: [...participantesMenu.rules],
    items: [participantesMenu],
};
